module.exports = __webpack_public_path__ + "static/media/logo.3338a485.png";